import React, { useContext, useEffect, useState } from 'react';
import Application from '../../../StateContext/Application.js';
import { BudgetHeadCreationBlue32, Cancel32, DeleteRed32, EditBlueBlue32, submit, Tax32, UpdateWhite32, EditIcon, DeleteIcon, Edit32WHITE, Delete32WHITE, Excel32, JPG32, PNG32, PDF32 } from '../../../../../public/LoginImages/importimages';
import ReleasefromFinance from './ReleasefromFinance.js';
import { apiurl } from '../../../../../path'
const ReleaseFromFinanceInwardList = () => {
    const operation = useContext(Application);
    const { GetReleaseFromFinanceList, ReleaseFromFinanceApproval, Usermenu } = operation;

    const [releaseFromFinance, setReleaseFromFinance] = useState([])
    const [loading, setLoading] = useState(false);
    const [SelectedOptions, setSelectedOptions] = useState("Pending");
    const [selectedBills, setSelectedBills] = useState([]);
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');
    const [rejectPanelhide, setRejectpanelhide] = useState(1);
    const [remark, setRemark] = useState("");

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
    console.log("currentbills", currentBills);

    const [menuData, setMenuData] = useState({});
    const [EditReleaseId, setEditReleaseId] = useState(null);
    const [showEditForm, setShowEditForm] = useState(false);
    const [editFundAllocation, setEditFundAllocation] = useState(null);

    useEffect(() => {
        ReleaseFromFinanceList()
    }, [])

    useEffect(() => {
        const getMenu = async () => {
            const res = await Usermenu();
            console.log("menuData", res);
            console.log(res);
            setMenuData(res?.Data || {});
        };
        getMenu();
    }, []);

    const isMaker =
        menuData?.Department_Name === "State Maker" &&
        menuData?.Role === "State Maker";

    const isChecker =
        menuData?.Department_Name === "State Checker" &&
        menuData?.Role === "State Checker";
    console.log("menuData", menuData);


    const ReleaseFromFinanceList = async () => {
        try {
            let res = await GetReleaseFromFinanceList();
            console.log("res", res);
            setFilteredBills(res?.result || []);
            setReleaseFromFinance(res?.result || []);
        } catch (err) {
            console.log(err);
        }
    };



    const handleCheckboxChange = (id) => {
        setSelectedBills((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((billId) => billId !== id)
                : [...prevSelected, id]
        );
    };

    console.log("Slected id form table :: ", selectedBills);
    console.log("Filtered data id form table :: ", filteredBills);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedBills(currentBills.map((bill) => bill.ReleaseID));
        } else {
            setSelectedBills([]);
        }
    };


    const approveorrejectSelected = async (condition) => {
        if (selectedBills.length === 0) {
            alert('No Budget Estimation selected for approval!');
            return;
        }
        console.log(selectedBills);
        setLoading(true);
        let shouldStart = window.confirm("Are you sure ???");

        if (shouldStart) {
            try {
                let response = await ReleaseFromFinanceApproval(selectedBills, condition, remark);
                if (response.message) {
                    alert(response.message);
                    setRejectpanelhide(0);
                    setRemark('');
                    setLoading(false)
                    window.location.reload();
                }
                if (response.error) {
                    alert(response.error)
                    setRejectpanelhide(0);
                    setRemark('');
                    setLoading(false)
                    window.location.reload();
                }
            } catch (error) {
                console.error('Error approving Fund:', error);
                alert('An error occurred while approving Fund.');
                setRejectpanelhide(0);
                setLoading(false)
                setRemark('');
                window.location.reload();
            }
        }
        else {
            alert(`AddFund ${condition} Operation Cancelled !!!`);
            setRemark('');
            setRejectpanelhide(0);
            window.location.reload();
        }
        setLoading(false); // Stop loader
    };



    const rejectSendbackbeforecheckup = (id) => {
        if (selectedBills.length > 0) {
            setRejectpanelhide(id);
        }
        else {
            alert("No Fund Selected !!!");
        }
    }


    return (
        <>
            {
                !showEditForm ? (
                    <>


                        <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                            <div className="col-12 px-3 m-auto">

                                <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <h5 className='my-auto fw-bold'>
                                        {/* <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' /> */}
                                        <span className='my-auto'>Fund Allocation Inward List</span>
                                    </h5>

                                    <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                        <img
                                            src="/Search32.png"
                                            alt="Search Icon"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "10px",
                                                transform: "translateY(-50%)",
                                                width: "16px",
                                                height: "16px",
                                                opacity: 0.6
                                            }}
                                        />
                                        <input
                                            type="text"
                                            placeholder="Search Here"
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            value={searchTerm}
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px 8px 32px", // left padding makes space for icon
                                                border: "1px solid #ccc",
                                                borderRadius: "8px",
                                                backgroundColor: "#f1f6fc",
                                                fontSize: "14px",
                                                color: "#333",
                                                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                outline: "none"
                                            }}
                                        />
                                    </div>
                                </div>


                                {loading && (
                                    <div
                                        style={{
                                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                                            display: 'flex', justifyContent: 'center', alignItems: 'center'
                                        }}>
                                        <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                                        <style>
                                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                        </style>
                                    </div>
                                )}


                                <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: 'scroll' }}>
                                    <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: "scroll" }}>

                                        {
                                            SelectedOptions === "Pending" &&
                                            (
                                                <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                            {isMaker && (<th style={{ padding: "10px" }}>Action</th>)}
                                                            <th style={{ minWidth: "50px", padding: "8px" }}>
                                                                {/* <input
                                                                     type="checkbox"
                                                                     onChange={handleSelectAll}
                                                                     checked={selectedBills.length === currentBills.length}
                                                                     className='my-auto'
                                                                     style={{ height: '1rem', width: '1rem' }}
                                                                 /> */}
                                                                Click
                                                            </th>
                                                            <th style={{ padding: "10px" }}>Release ID</th>
                                                            <th style={{ padding: "10px" }}>Financial Year</th>
                                                            <th style={{ padding: "10px" }}>Project Name</th>
                                                            <th style={{ padding: "10px" }}>Release Amount</th>
                                                            {/* <th style={{ padding: "10px" }}>CRC</th>
                                                <th style={{ padding: "10px" }}>Budget Head</th> */}
                                                            <th style={{ padding: "10px" }}>ReleaseDate</th>
                                                            {isMaker && (<th style={{ padding: "10px" }}>Remark</th>)}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            currentBills.length <= 0 ?
                                                                (
                                                                    <tr>
                                                                        <td colSpan="12" style={{ textAlign: 'center', padding: '15px 10px', backgroundColor: '#f9f9f9' }}>
                                                                            No data available
                                                                        </td>
                                                                    </tr>
                                                                )
                                                                :
                                                                (
                                                                    currentBills?.map((releasefromfdutf, index) => {
                                                                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                                        return (
                                                                            <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>
                                                                                {isMaker && (
                                                                                    <td style={{ padding: "10px", textAlign: "center" }}>
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                console.log("Selected Fund For Edit:", releasefromfdutf);
                                                                                                setEditFundAllocation(releasefromfdutf);
                                                                                                console.log(releasefromfdutf);
                                                                                                setShowEditForm(true);
                                                                                            }}
                                                                                            style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                                                                        >
                                                                                            <img src={EditIcon} alt="Edit" style={{ width: "20px", height: "20px" }} />
                                                                                        </button>
                                                                                    </td>
                                                                                )}


                                                                                <td style={{ textAlign: "center" }}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className='my-auto'
                                                                                        style={{ height: '1rem', width: '1rem' }}
                                                                                        checked={selectedBills.includes(releasefromfdutf.ReleaseID)}
                                                                                        onChange={() => handleCheckboxChange(releasefromfdutf.ReleaseID)}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ padding: "10px" }}>{releasefromfdutf.ReleaseID}</td>
                                                                                <td style={{ padding: "10px" }}>{releasefromfdutf.FinancialYear}</td>
                                                                                <td style={{ padding: "10px" }}>{releasefromfdutf.ProjectName}</td>
                                                                                <td style={{ padding: "10px" }}>{releasefromfdutf.ReleaseAmount}</td>
                                                                                {/* <td style={{ padding: "10px" }}>{releasefromfdutf.CRC}</td>
                                                                    <td style={{ padding: "10px" }}>{releasefromfdutf.BudgetHead}</td> */}
                                                                                <td style={{ padding: "10px" }}>{releasefromfdutf.ReleaseDate?.split('T')[0].replace(' ')}</td>
                                                                                {isMaker && (<td style={{ padding: "10px" }}>{releasefromfdutf.Remark}</td>)}
                                                                            </tr>
                                                                        )
                                                                    })
                                                                )
                                                        }
                                                    </tbody>
                                                </table>
                                            )
                                        }

                                    </div>

                                    <div className='col-12 mt-3'>
                                        <div className="row">
                                            <div className='col-6 text-start' style={{ display: 'flex', justifyContent: 'left' }}>
                                                <button
                                                    onClick={() => approveorrejectSelected("Approved")}
                                                    disabled={selectedBills.length <= 0 ? true : loading}
                                                    className='ms-0'
                                                    style={{
                                                        display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                        backgroundColor: selectedBills.length <= 0 ? (
                                                            'rgba(141, 141, 141, 0.97)'
                                                        ) : ('#39B54A'), color: 'white', borderRadius: '8px',
                                                        cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                                    }}
                                                >
                                                    <img src='/Approve-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
                                                </button>

                                                <button
                                                    onClick={() => rejectSendbackbeforecheckup(2)} disabled={selectedBills.length <= 0 ? true : loading}
                                                    style={{
                                                        display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                        background: selectedBills.length <= 0 ? (
                                                            'rgba(141, 141, 141, 0.97)'
                                                        ) : ('#C1272D'), color: 'white', borderRadius: '8px',
                                                        cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                                    }}
                                                ><img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Reject Selected'}
                                                </button>
                                                {isChecker && (
                                                    <button
                                                        onClick={() => rejectSendbackbeforecheckup(3)}
                                                        disabled={selectedBills.length <= 0 || loading}
                                                        style={{
                                                            display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', fontWeight: "600",
                                                            background: selectedBills.length <= 0
                                                                ? 'rgba(141, 141, 141, 0.97)'
                                                                : 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                                                            color: 'white',
                                                            borderRadius: '8px',
                                                            cursor: selectedBills.length <= 0 || loading
                                                                ? 'not-allowed'
                                                                : 'pointer'
                                                        }}
                                                    >
                                                        <img
                                                            src='/Send-Back-Selected32.png'
                                                            style={{
                                                                width: '1rem',
                                                                height: "1rem",
                                                                filter: 'brightness(0) invert(1)'
                                                            }}
                                                        />
                                                        {loading ? 'Processing...' : 'Send Back Selected'}
                                                    </button>
                                                )}


                                                {/* <button
                                        onClick={() => rejectSendbackbeforecheckup(3)} disabled={selectedBills.length <= 0 ? true : loading}
                                        style={{
                                            display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                            background: selectedBills.length <= 0 ? (
                                                'rgba(141, 141, 141, 0.97)'
                                            ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'), color: 'white', borderRadius: '8px',
                                            cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                        }}
                                    ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
                                    </button> */}
                                            </div>

                                            <div className="col-6 text-end">
                                                {/* First Page Button */}
                                                <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                                                    &laquo;
                                                </button>
                                                {/* Previous Button */}
                                                <button
                                                    onClick={() => setCurrentPage(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                    &lt;
                                                </button>

                                                <button
                                                    style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                                                </button>
                                                {/* Next Button */}
                                                <button
                                                    onClick={() => setCurrentPage(currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                    &gt;
                                                </button>
                                                {/* Last Page Button */}
                                                <button
                                                    onClick={() => setCurrentPage(totalPages)}
                                                    disabled={currentPage === totalPages}
                                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                    &raquo;
                                                </button>
                                            </div>
                                        </div>


                                    </div>
                                </div>



                            </div>
                        </div>



                        {

                            rejectPanelhide === 2 &&

                            <div className='col-12 RejectPanelContainer' style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'rgba(0, 0, 0, 0.35)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 9999
                            }}>
                                <div className="Rejectpanel">
                                    <form action="">

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3">
                                                    <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                                                </div>
                                                <div className="col-8">
                                                    <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
                                                    </textarea>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                    <div className="col-12 ms-auto my-4">
                                        <div className="row">
                                            {/* <div className="col-3"></div> */}
                                            <div className="col-9 m-auto">
                                                <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                                    <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} /> Reject</button>
                                                    <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        }

                        {
                            rejectPanelhide === 3 &&

                            <div className='col-12 RejectPanelContainer' style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'rgba(0, 0, 0, 0.35)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 9999
                            }}>
                                <div className="Rejectpanel" style={{
                                    width: '500px',
                                    background: '#fff',
                                    borderRadius: '10px',
                                    padding: '20px',
                                    boxShadow: '0 0 15px rgba(0,0,0,0.2)'
                                }}
                                >
                                    <form action="">

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3">
                                                    <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                                                </div>
                                                <div className="col-8">
                                                    <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
                                                    </textarea>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                    <div className="col-12 ms-auto my-4">
                                        <div className="row">
                                            {/* <div className="col-3"></div> */}
                                            <div className="col-9 m-auto">
                                                <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                                    <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
                                                    <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        }

                    </>
                ) : (
                    <ReleasefromFinance

                        isEdit={true}
                        projectData={editFundAllocation}
                        onSuccess={() => {
                            setShowEditForm(false);
                            ReleaseFromFinanceList();           // Refresh table
                            setSelectedBills([]);
                        }}
                        onCancel={() => {
                            setShowEditForm(false);
                        }}
                    />
                )
            }
        </>

    )
}

export default ReleaseFromFinanceInwardList;